module.exports = __webpack_public_path__ + "img/ad.3c827b96.svg";